import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "nonzero",
      d: "M15 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4m2 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m0 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
    }, null, -1)
  ]))]))
}
export default { render: render }